"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "getLageOutputCacheLocation", {
    enumerable: true,
    get: function() {
        return getLageOutputCacheLocation;
    }
});
const _cache = require("@lage-run/cache");
const _path = /*#__PURE__*/ _interop_require_default(require("path"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function getLageOutputCacheLocation(root, hash) {
    const outputPath = (0, _cache.getLogsCacheDirectory)(root, hash);
    return _path.default.join(outputPath, hash + ".log");
}
